# UTILS
import './utils.coffee'

# COMMONS
import './commons.coffee'

# PARTICLES
import '../Components/Particles/Icon/Icon.coffee'
import '../Components/Particles/Image/Image.coffee'
import '../Components/Particles/Loader/Loader.coffee'

# ATOMS
import '../Components/Atoms/Badge/Badge.coffee'
import '../Components/Atoms/Bookmark/Bookmark.coffee'
import '../Components/Atoms/BookmarkButton/BookmarkButton.coffee'
import '../Components/Atoms/Button/Button.coffee'
import '../Components/Atoms/Checkbox/Checkbox.coffee'
import '../Components/Atoms/Headline/Headline.coffee'
import '../Components/Atoms/Input/Input.coffee'
import '../Components/Atoms/KebabButton/KebabButton.coffee'
import '../Components/Atoms/LikeButton/LikeButton.coffee'
import '../Components/Atoms/LineChart/LineChart.coffee'
import '../Components/Atoms/LinkButton/LinkButton.coffee'
import '../Components/Atoms/ProfilePic/ProfilePic.coffee'
import '../Components/Atoms/Progressbar/Progressbar.coffee'
import '../Components/Atoms/Range/Range.coffee'
import '../Components/Atoms/Select/Select.coffee'
import '../Components/Atoms/StarRating/StarRating.coffee'
import '../Components/Atoms/State/State.coffee'
import '../Components/Atoms/Tag/Tag.coffee'
import '../Components/Atoms/Textarea/Textarea.coffee'

# MOLECULES
import '../Components/Molecules/AccountMenu/AccountMenu.coffee'
import '../Components/Molecules/ArticleHeader/ArticleHeader.coffee'
import '../Components/Molecules/Breadcrumbs/Breadcrumbs.coffee'
import '../Components/Molecules/DayTipTile/DayTipTile.coffee'
import '../Components/Molecules/ExpandableText/ExpandableText.coffee'
import '../Components/Molecules/ExpandableTile/ExpandableTile.coffee'
import '../Components/Molecules/Form/Form.coffee'
import '../Components/Molecules/ForumEntry/ForumEntry.coffee'
import '../Components/Molecules/IconNumberTile/IconNumberTile.coffee'
import '../Components/Molecules/InfoCard/InfoCard.coffee'
import '../Components/Molecules/NewsEntry/NewsEntry.coffee'
import '../Components/Molecules/NumbersCard/NumbersCard.coffee'
import '../Components/Molecules/PageTeaser/PageTeaser.coffee'
import '../Components/Molecules/Pagination/Pagination.coffee'
import '../Components/Molecules/PostTeaser/PostTeaser.coffee'
import '../Components/Molecules/Richtext/Richtext.coffee'
import '../Components/Molecules/Searchbar/Searchbar.coffee'
import '../Components/Molecules/Sources/Sources.coffee'
import '../Components/Molecules/SpeechBubble/SpeechBubble.coffee'
import '../Components/Molecules/SuccessStoryInfo/SuccessStoryInfo.coffee'
import '../Components/Molecules/TopicsNavigation/TopicsNavigation.coffee'
import '../Components/Molecules/UserCard/UserCard.coffee'
import '../Components/Molecules/UserInfo/UserInfo.coffee'

# ORGANISMS
import '../Components/Organisms/AddEntry/AddEntry.coffee'
import '../Components/Organisms/Article/Article.coffee'
import '../Components/Organisms/CommunityTeaser/CommunityTeaser.coffee'
import '../Components/Organisms/Conversations/Conversations.coffee'
import '../Components/Organisms/DayTipTileSlider/DayTipTileSlider.coffee'
import '../Components/Organisms/DeleteEntry/DeleteEntry.coffee'
import '../Components/Organisms/ExitProgram/ExitProgram.coffee'
import '../Components/Organisms/ExpandableTilesGrid/ExpandableTilesGrid.coffee'
import '../Components/Organisms/Footer/Footer.coffee'
import '../Components/Organisms/ForumEntriesOverview/ForumEntriesOverview.coffee'
import '../Components/Organisms/Header/Header.coffee'
import '../Components/Organisms/InfoLibrary/InfoLibrary.coffee'
import '../Components/Organisms/Login/Login.coffee'
import '../Components/Organisms/NewsEntriesOverview/NewsEntriesOverview.coffee'
import '../Components/Organisms/Overlay/Overlay.coffee'
import '../Components/Organisms/PostEntry/PostEntry.coffee'
import '../Components/Organisms/ProfileHead/ProfileHead.coffee'
import '../Components/Organisms/ProfileOverview/ProfileOverview.coffee'
import '../Components/Organisms/Quiz/Quiz.coffee'
import '../Components/Organisms/ReportEntry/ReportEntry.coffee'
import '../Components/Organisms/SavingsCalculator/SavingsCalculator.coffee'
import '../Components/Organisms/SearchResults/SearchResults.coffee'
import '../Components/Organisms/SuccessStoriesOverview/SuccessStoriesOverview.coffee'
import '../Components/Organisms/SuccessStory/SuccessStory.coffee'
import '../Components/Organisms/SuccessStorySlider/SuccessStorySlider.coffee'
import '../Components/Organisms/SuccessStoryTileSlider/SuccessStoryTileSlider.coffee'
import '../Components/Organisms/ThreadHead/ThreadHead.coffee'
import '../Components/Organisms/ThreadOverview/ThreadOverview.coffee'
import '../Components/Organisms/UserCardSlider/UserCardSlider.coffee'

window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }